import I_NA from './NA';
import I_EU from './EU';
import { useGlobal } from '@/utils/useGlobal';

export default function G() {
    const { useRouter } = useGlobal();
    const { locale } = useRouter();
    const EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'];

    return <>{EU_SITES?.includes(locale) ? <I_EU /> : <I_NA />}</>;
}
